import { createContext, useContext, useEffect, useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { api } from './api.js';
import { OutboxBanner, Spinner } from './components.jsx';
import Search from './pages/Search.jsx';
import Job from './pages/Job.jsx';
import AddNote from './pages/AddNote.jsx';
import AddFiles from './pages/AddFiles.jsx';
import AddContact from './pages/AddContact.jsx';
import Done from './pages/Done.jsx';
import NewJob from './pages/NewJob.jsx';
import Sketch from './pages/Sketch.jsx';
import Goods from './pages/Goods.jsx';

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

export default function App() {
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get('/api/me').then(setMe).catch(() => {});
  }, []);

  if (!me) {
    return <div className="flex min-h-screen items-center justify-center"><Spinner className="h-10 w-10" /></div>;
  }

  return (
    <MeContext.Provider value={me}>
      <div className="mx-auto min-h-screen max-w-xl">
        <header className="sticky top-0 z-10 flex items-center justify-between bg-navy px-4 pb-3 pt-[max(0.75rem,env(safe-area-inset-top))] text-white dark:bg-charcoal dark:border-b dark:border-white/10">
          <Link to="/" className="text-xl font-bold tracking-tight">Onsite</Link>
          <span className="text-sm opacity-80">{me.user.name.split(' ')[0]}</span>
        </header>
        <OutboxBanner />
        <main className="p-4 pb-[max(2rem,env(safe-area-inset-bottom))]">
          <Routes>
            <Route path="/" element={<Search />} />
            <Route path="/new" element={<NewJob />} />
            <Route path="/job/:id" element={<Job />} />
            <Route path="/job/:id/note" element={<AddNote />} />
            <Route path="/job/:id/files" element={<AddFiles />} />
            <Route path="/job/:id/sketch" element={<Sketch />} />
            <Route path="/job/:id/goods/:dir" element={<Goods />} />
            <Route path="/job/:id/contact" element={<AddContact />} />
            <Route path="/job/:id/done" element={<Done />} />
            <Route path="*" element={<Search />} />
          </Routes>
        </main>
      </div>
    </MeContext.Provider>
  );
}
